import React, { useEffect, useState } from 'react'
import Header from '../components/header'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader/Loader'
import { slice } from 'lodash'
import Form from '../components/form'
import { useParams } from 'react-router-dom'
import { auctionInvListRequest } from '../store/actions/auctionInvAction'
import WebViewAutionData from '../containers/autionDataList/webViewAutionData'
import MobileViewAutionData from '../containers/autionDataList/mobileViewAutionData'
import Cards from '../components/cards'
import NoDataFound from '../components/notDataFound/noDataFound'

export default function AuctionDataPage() {
    const [index, setIndex] = useState(20)
    const [isCompleted, setIsCompleted] = useState(false)
    const dispatch = useDispatch()
    const auctionInvListObj = useSelector((state) => state.auctionInvReducer)
    const { resauctionInvData, loading, error } = auctionInvListObj

    const loginObj = useSelector((state) => state.loginReducer)
    const { loginResult } = loginObj
    const initialPosts = resauctionInvData?.data
        ? slice(resauctionInvData?.data, 0, index)
        : []

    const { auctionId } = useParams()

    const loadMore = () => {
        setIndex(index + 10)
        if (index >= resauctionInvData?.data?.length) {
            setIsCompleted(true)
        } else {
            setIsCompleted(false)
        }
    }

    useEffect(() => {
        dispatch(
            auctionInvListRequest({
                reqAuctionId: auctionId,
                user_id: loginResult?.data?.user_id,
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const refreshInterval = setInterval(() => {
            dispatch(
                auctionInvListRequest({
                    reqAuctionId: auctionId,
                    user_id: loginResult?.data?.user_id,
                })
            )
        }, 60000)

        return () => {
            clearInterval(refreshInterval)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            <Header>
                <Header.MaxWidth>
                    <Header.Logo
                        src="../assets/title/Tractor world Logo.svg"
                        alt="Logo"
                    />
                </Header.MaxWidth>
            </Header>
            {loading &&
            (!resauctionInvData || resauctionInvData?.data?.length === 0) ? (
                <Loader />
            ) : (
                <>
                    <Cards.MobileViewVisibility>
                        <MobileViewAutionData data={resauctionInvData?.data} />
                    </Cards.MobileViewVisibility>
                    <Cards.DesktopViewVisibility>
                        <WebViewAutionData data={resauctionInvData?.data} />
                    </Cards.DesktopViewVisibility>
                </>
            )}
            <br />
            {/* {(resauctionInvData?.data || '')?.length !==
            (initialPosts || '')?.length ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}
                >
                    {!isCompleted && resauctionInvData && (
                        <Form.Button
                            onClick={loadMore}
                            type="button"
                            style={{
                                backgroundColor: '#652078',
                                color: '#FFFF',
                            }}
                        >
                            Load More
                        </Form.Button>
                    )}
                </div>
            ) : (
                ''
            )} */}

            {!loading && (resauctionInvData?.data || '').length === 0 && (
                <NoDataFound
                    msg={error ? 'Something went wrong...' : 'No Data Found'}
                />
            )}
        </>
    )
}
